/* Mancini Market · interacciones de la tienda (prefijo mm-) */
(function () {
  if (window.__mmInit) return;
  window.__mmInit = true;

  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var tactil = window.matchMedia('(hover: none)').matches;

  /* Reveals al entrar en pantalla (un solo observer) */
  var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entradas) {
    entradas.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('mm-visible'); observer.unobserve(e.target); }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }) : null;

  function initReveals(raiz) {
    raiz.querySelectorAll('.mm-reveal, [data-mm-observa]').forEach(function (el) {
      if (el.dataset.mmRev) return;
      el.dataset.mmRev = '1';
      if (!observer || reducido) { el.classList.add('mm-visible'); return; }
      observer.observe(el);
    });
  }

  /* Héroe: el producto se inclina hacia el mouse */
  function initHero(raiz) {
    raiz.querySelectorAll('[data-mm-tilt]').forEach(function (zona) {
      if (zona.dataset.mmInit) return;
      zona.dataset.mmInit = '1';
      var prod = zona.querySelector('.mm-hero__producto');
      var sombra = zona.querySelector('.mm-hero__sombra');
      var max = parseFloat(zona.dataset.mmTilt) || 8;
      if (!prod || reducido || tactil) return;
      zona.addEventListener('mousemove', function (ev) {
        var r = zona.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width - 0.5;
        var y = (ev.clientY - r.top) / r.height - 0.5;
        prod.style.transform = 'rotateY(' + (x * max) + 'deg) rotateX(' + (-y * max) + 'deg) translateZ(10px)';
        if (sombra) sombra.style.transform = 'translateX(' + (-x * 24) + 'px) scaleX(' + (1 - Math.abs(x) * 0.2) + ')';
      });
      zona.addEventListener('mouseleave', function () {
        prod.style.transform = '';
        if (sombra) sombra.style.transform = '';
      });
    });
  }

  /* Qué viene en la caja: punto ↔ ítem de la lista */
  function initCaja(raiz) {
    raiz.querySelectorAll('[data-mm-caja]').forEach(function (caja) {
      if (caja.dataset.mmInit) return;
      caja.dataset.mmInit = '1';
      var puntos = caja.querySelectorAll('.mm-caja__punto');
      var items = caja.querySelectorAll('.mm-caja__item');
      function activa(i) {
        items.forEach(function (it, k) { it.classList.toggle('mm-activo', k === i); });
      }
      puntos.forEach(function (p, i) {
        p.addEventListener('mouseenter', function () { activa(i); });
        p.addEventListener('focus', function () { activa(i); });
        p.addEventListener('click', function () { activa(i); if (items[i]) items[i].scrollIntoView({ block: 'nearest', behavior: reducido ? 'auto' : 'smooth' }); });
      });
      items.forEach(function (it, i) { it.addEventListener('mouseenter', function () { activa(i); }); });
    });
  }

  /* Preguntas frecuentes */
  function initFaq(raiz) {
    raiz.querySelectorAll('.mm-faq__q').forEach(function (btn) {
      if (btn.dataset.mmInit) return;
      btn.dataset.mmInit = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.mm-faq__item');
        var abierto = item.classList.toggle('mm-abierto');
        btn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  /* Botón magnético */
  function initMagnetico(raiz) {
    raiz.querySelectorAll('.mm-magnetico').forEach(function (el) {
      if (el.dataset.mmInit) return;
      el.dataset.mmInit = '1';
      if (reducido || tactil) return;
      var zona = el.parentElement;
      zona.addEventListener('mousemove', function (ev) {
        var r = el.getBoundingClientRect();
        var dx = ev.clientX - (r.left + r.width / 2);
        var dy = ev.clientY - (r.top + r.height / 2);
        var d = Math.sqrt(dx * dx + dy * dy);
        if (d < 160) el.style.transform = 'translate(' + (dx / 160 * 6) + 'px,' + (dy / 160 * 6) + 'px)';
        else el.style.transform = '';
      });
      zona.addEventListener('mouseleave', function () { el.style.transform = ''; });
    });
  }

  /* Página de producto: galería, variantes y barra fija */
  function initProducto(raiz) {
    raiz.querySelectorAll('[data-mm-pdp]').forEach(function (pdp) {
      if (pdp.dataset.mmInit) return;
      pdp.dataset.mmInit = '1';
      var principal = pdp.querySelector('.mm-galeria__principal img');
      pdp.querySelectorAll('.mm-galeria__mini').forEach(function (mini) {
        mini.addEventListener('click', function () {
          if (!principal) return;
          principal.style.opacity = '0';
          setTimeout(function () {
            principal.src = mini.dataset.src;
            principal.alt = mini.dataset.alt || '';
            principal.style.opacity = '1';
          }, 180);
          pdp.querySelectorAll('.mm-galeria__mini').forEach(function (m) { m.setAttribute('aria-current', m === mini ? 'true' : 'false'); });
        });
      });

      var datos = pdp.querySelector('[data-mm-variantes]');
      if (datos) {
        var variantes = JSON.parse(datos.textContent);
        var selects = pdp.querySelectorAll('[data-mm-opcion]');
        var inputId = pdp.querySelector('input[name="id"]');
        var precio = pdp.querySelectorAll('[data-mm-precio]');
        var botones = pdp.querySelectorAll('[data-mm-agregar]');
        var formato = pdp.dataset.mmMoneda || '';
        selects.forEach(function (s) {
          s.addEventListener('change', function () {
            var elegido = Array.prototype.map.call(selects, function (x) { return x.value; });
            var v = variantes.find(function (va) { return va.options.every(function (o, i) { return o === elegido[i]; }); });
            if (!v) return;
            if (inputId) inputId.value = v.id;
            precio.forEach(function (p) { p.textContent = formatea(v.price, formato); });
            botones.forEach(function (b) {
              b.disabled = !v.available;
              var t = b.querySelector('[data-mm-texto]');
              if (t) t.textContent = v.available ? b.dataset.textoOk : b.dataset.textoAgotado;
            });
          });
        });
      }

      var barra = pdp.parentElement.querySelector('.mm-barra-fija');
      var compra = pdp.querySelector('.mm-pdp__botones');
      if (barra && compra && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (e) {
          barra.classList.toggle('mm-visible', !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
        }).observe(compra);
      }
    });
  }

  function formatea(centavos, formato) {
    var n = (centavos / 100).toFixed(2).split('.');
    var enteros = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var cifra = n[1] === '00' ? enteros : enteros + ',' + n[1];
    return formato ? formato.replace(/\{\{\s*\w+\s*\}\}/, cifra) : '$' + cifra;
  }


  /* Línea de tiempo de la entrega: fechas reales desde hoy (sin contar domingos) */
  function initEntrega(raiz) {
    raiz.querySelectorAll('[data-mm-entrega]').forEach(function (caja) {
      if (caja.dataset.mmListo) return; caja.dataset.mmListo = '1';
      var min = +caja.dataset.min || 3, max = +caja.dataset.max || 5;
      function suma(n) { var d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) n--; } return d; }
      function corto(d) {
        var p = new Intl.DateTimeFormat('es-CO', { day: 'numeric', month: 'short' }).formatToParts(d);
        var dia = '', mes = '';
        p.forEach(function (x) { if (x.type === 'day') dia = x.value; if (x.type === 'month') mes = x.value.replace('.', ''); });
        return dia + ' ' + mes;
      }
      var a = suma(min), b = suma(max);
      var rango = a.getMonth() === b.getMonth() ? a.getDate() + ' – ' + corto(b) : corto(a) + ' – ' + corto(b);
      var t = { '0': 'Hoy, ' + corto(new Date()), '1': corto(suma(1)), 'rango': rango };
      caja.querySelectorAll('[data-mm-dia]').forEach(function (el) { el.textContent = t[el.dataset.mmDia]; });
    });
  }

  /* Videos: siempre en bucle, sin controles; solo se reproducen cuando se ven */
  function initVideos(raiz) {
    raiz.querySelectorAll('[data-mm-videos]').forEach(function (caja) {
      if (caja.dataset.mmListo) return; caja.dataset.mmListo = '1';
      var videos = caja.querySelectorAll('video');
      videos.forEach(function (v) {
        v.muted = true; v.defaultMuted = true; v.loop = true; v.controls = false; v.playsInline = true;
        v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
        v.addEventListener('ended', function () { v.currentTime = 0; v.play(); });
        v.addEventListener('pause', function () { if (v.dataset.mmVisible === '1' && !document.hidden) v.play().catch(function () {}); });
      });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entradas) {
          entradas.forEach(function (e) {
            var v = e.target; v.dataset.mmVisible = e.isIntersecting ? '1' : '0';
            if (e.isIntersecting) { v.preload = 'auto'; v.play().catch(function () {}); } else v.pause();
          });
        }, { rootMargin: '200px 0px' });
        videos.forEach(function (v) { io.observe(v); });
      } else videos.forEach(function (v) { v.play().catch(function () {}); });
      var pista = caja.querySelector('[data-mm-videos-pista]'), puntos = caja.querySelectorAll('.mm-videos__puntos span');
      if (pista && puntos.length) pista.addEventListener('scroll', function () {
        var hijos = pista.children, centro = pista.scrollLeft + pista.clientWidth / 2, i = 0, mejor = 1e9;
        for (var k = 0; k < hijos.length; k++) { var c = hijos[k].offsetLeft + hijos[k].offsetWidth / 2, dd = Math.abs(c - centro); if (dd < mejor) { mejor = dd; i = k; } }
        puntos.forEach(function (p, k) { p.classList.toggle('mm-activo', k === i); });
      }, { passive: true });
    });
  }

  /* Reseñas: filtros, orden, vista, «ver más», visor de fotos y formulario con foto */
  function initResenas(raiz) {
    raiz.querySelectorAll('[data-mm-resenas]').forEach(function (caja) {
      if (caja.dataset.mmListo) return; caja.dataset.mmListo = '1';
      var seccion = caja.closest('section') || document;
      var lista = caja.querySelector('[data-mm-resenas-lista]');
      var items = Array.prototype.slice.call(lista.children);
      var porPagina = +caja.dataset.porPagina || 6, visibles = porPagina, filtro = 'todas', orden = 'destacadas';
      var mas = caja.querySelector('[data-mm-resenas-mas]'), vacio = caja.querySelector('[data-mm-resenas-vacio]');
      function pinta() {
        var orden_items = items.slice().sort(function (a, b) {
          if (orden === 'mejor') return (b.dataset.estrellas - a.dataset.estrellas) || (a.dataset.orden - b.dataset.orden);
          if (orden === 'menor') return (a.dataset.estrellas - b.dataset.estrellas) || (a.dataset.orden - b.dataset.orden);
          return a.dataset.orden - b.dataset.orden;
        });
        var n = 0;
        orden_items.forEach(function (it) {
          lista.appendChild(it);
          var pasa = filtro === 'todas' || (filtro === 'foto' ? it.hasAttribute('data-foto') : filtro.indexOf('p:') === 0 ? it.dataset.producto === filtro.slice(2) : it.dataset.estrellas === filtro);
          if (pasa) n++;
          it.hidden = !pasa || n > visibles;
        });
        mas.hidden = n <= visibles; vacio.hidden = n > 0;
        caja.querySelectorAll('[data-filtro]').forEach(function (b) { if (b.classList.contains('mm-chip')) b.setAttribute('aria-pressed', b.dataset.filtro === filtro ? 'true' : 'false'); });
      }
      caja.querySelectorAll('[data-filtro]').forEach(function (b) {
        b.addEventListener('click', function () { filtro = b.dataset.filtro; visibles = porPagina; pinta(); });
      });
      caja.querySelector('[data-mm-orden]').addEventListener('change', function (e) { orden = e.target.value; pinta(); });
      caja.querySelectorAll('[data-vista]').forEach(function (b) {
        if (b === lista) return;
        b.addEventListener('click', function () {
          lista.dataset.vista = b.dataset.vista;
          caja.querySelectorAll('button[data-vista]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        });
      });
      mas.addEventListener('click', function () { visibles += porPagina; pinta(); });
      pinta();
      if (/contact_posted=true/.test(location.search)) setTimeout(function () { caja.scrollIntoView({ block: 'start' }); }, 300);

      var visor = seccion.querySelector('[data-mm-visor]');
      lista.addEventListener('click', function (e) {
        var b = e.target.closest('[data-mm-foto]'); if (!b || !visor) return;
        visor.querySelector('[data-mm-visor-img]').src = b.dataset.mmFoto; visor.showModal();
      });
      if (visor) {
        visor.querySelector('[data-mm-visor-cerrar]').addEventListener('click', function () { visor.close(); });
        visor.addEventListener('click', function (e) { if (e.target === visor) visor.close(); });
      }

      var dlg = seccion.querySelector('[data-mm-resenar]'); if (!dlg) return;
      var form = dlg.querySelector('[data-mm-resenar-form]');
      var archivo = dlg.querySelector('[data-mm-foto-input]'), previa = dlg.querySelector('[data-mm-foto-previa]');
      var error = dlg.querySelector('[data-mm-resenar-error]'), enviar = dlg.querySelector('[data-mm-resenar-enviar]');
      caja.querySelector('[data-mm-resenar-abrir]').addEventListener('click', function () { dlg.showModal(); });
      dlg.querySelector('[data-mm-resenar-cerrar]').addEventListener('click', function () { dlg.close(); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      archivo.addEventListener('change', function () {
        var f = archivo.files[0]; error.hidden = true;
        if (!f) { previa.hidden = true; return; }
        if (f.size > 15 * 1024 * 1024) { archivo.value = ''; previa.hidden = true; error.textContent = 'La foto pesa más de 15 MB. Prueba con otra.'; error.hidden = false; return; }
        previa.src = URL.createObjectURL(f); previa.hidden = false;
      });
      function achica(f) {
        return new Promise(function (ok) {
          var img = new Image();
          img.onload = function () {
            var esc = Math.min(1, 1600 / Math.max(img.width, img.height)), c = document.createElement('canvas');
            c.width = Math.round(img.width * esc); c.height = Math.round(img.height * esc);
            c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
            c.toBlob(function (b) { ok(b || f); }, 'image/jpeg', .86);
          };
          img.onerror = function () { ok(f); };
          img.src = URL.createObjectURL(f);
        });
      }
      /* La foto se guarda en los archivos de la tienda (vía el carrito, que queda como estaba) */
      function subeFoto(f) {
        var campo = document.querySelector('form[action*="/cart/add"] input[name="id"]');
        var id = caja.dataset.variante || (campo && campo.value);
        if (!id) return Promise.resolve('');
        return achica(f).then(function (b) {
          var fd = new FormData();
          fd.append('id', id); fd.append('quantity', '1');
          fd.append('properties[_foto_resena]', b, 'resena.jpg');
          return fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        }).then(function (r) { return r.json(); }).then(function (j) {
          var url = j && j.properties ? j.properties._foto_resena : '';
          if (!j || !j.key) return url || '';
          return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: j.key, quantity: 0 }) }).then(function () { return url; });
        }).catch(function () { return ''; });
      }
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var calif = form.querySelector('input[type=radio]:checked');
        if (!calif) { error.textContent = 'Elige de 1 a 5 estrellas.'; error.hidden = false; return; }
        if (!form.reportValidity()) return;
        form.querySelector('[data-mm-calif-valor]').value = calif.value + ' de 5';
        enviar.disabled = true; enviar.textContent = 'Enviando…'; error.hidden = true;
        var f = archivo.files[0];
        (f ? subeFoto(f) : Promise.resolve('')).then(function (url) {
          form.querySelector('[data-mm-foto-url]').value = url || (f ? 'No se pudo adjuntar la foto' : 'Sin foto');
          HTMLFormElement.prototype.submit.call(form);
        });
      });
    });
  }

  function initTodo(ev) {
    var raiz = ev && ev.target && ev.target.querySelectorAll ? ev.target : document;
    initReveals(raiz);
    initHero(raiz);
    initCaja(raiz);
    initFaq(raiz);
    initMagnetico(raiz);
    initProducto(raiz);
    initEntrega(raiz);
    initVideos(raiz);
    initResenas(raiz);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo);
  else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
